import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";

import ApiService from "services/ApiService";

import Mood from "components/Mood";
import Nps from "components/NPS";
import ModalMessage from "components/ModalMessage";
import { translate } from 'react-i18next'; 

import {
  Button,
  ContentContainer,
  Container,
  FooterContainer,
  HeaderContainer,
  SubHeader,
  SubTitle,
} from "./styles.js";

const MoodModal = ({
  isOpen,
  setIsOpen = () => {},
  setLastMoodSelected = () => {},
  t
}) => {
  const [noData, setNoData] = useState(true);
  const [requiredMoodAction, setRequiredMoodAction] = useState(false);
  const [requiredNPSAction, setRequiredNPSAction] = useState(false);
  const [buttonIsDisabled, setButtonIsDisabled] = useState(true);
  const [moodSelected, setMoodSelected] = useState(0);
  const [npsSelected, setNpsSelected] = useState(-1);
  const [npsId, setNpsId] = useState(null);
  const [moodMessage, setMoodMessage] = useState('');
  const [message, setMessage] = useState('');
  const [npsJustification, setNpsJustification] = useState('');
  const [showJustificationNpsInput, setShowJustificationNpsInput] = useState(false);
  const [moods, setMoods] = useState([]);
  const [moodModalTitle, setMoodModalTitle] = useState("");
  const [showNpsBox, setShowNpsBox] = useState(true);
  const [mandatoryLabel, setMandatoryLabel] = useState(false);
  const [detractorsMustJustify, setDetractorsMustJustify] = useState(false);
  const [passivesMustJustify, setPassivesMustJustify] = useState(false);
  const [promotersMustJustify, setPromotersMustJustify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModalMood, setShowModalMood] = useState(false);

  const handleReason = (reason) => [
    'backdropClick',
    'escapeKeyDown'
  ].some(r => r === reason)

  const handleOnClose = (_, reason) => {
    if (handleReason(reason) && requiredMoodAction) {
      return;
    }
    setIsOpen(false);
    updateLocalStorage("showModalMood", 0);
    saveCancelNps(1)
  }

  const saveCancelNps = async (value) => {
    setLoading(true);
    return await ApiService.post("/api/v1/user/nps/cancel", {
      value: value,
    })
      .then(({ data }) => {})
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };
   
  const updateLocalStorage = (key, value) => {
    const localMood = JSON.parse(localStorage.getItem('USER_MOOD'));
    const {user} = localMood;
    const newLocalMood = {...localMood, user: {...user, [key]: value}};
    localStorage.setItem('USER_MOOD', JSON.stringify(newLocalMood));
  }

  const save = async (url, data, cond, keyInfo) => {
    if(cond){
      setLoading(true);
      return await ApiService
        .post(url, data)
        .then(({data}) => {
          keyInfo.forEach((keyInfo) =>updateLocalStorage(...keyInfo));
          return data
        })
        .catch(err => err)
        .finally(() => {
          setLoading(false);
        });
    }
    return {status: "notSent"};
  }

  const saveData = async () => {
    if(buttonIsDisabled) return;
    setButtonIsDisabled(true);

    let npsResponse = null;
    let npsUserAnswerId = null;
    if (requiredNPSAction) {
      npsResponse = await save('/api/v1/user/nps', {
        npsId: npsId,
        answer: npsSelected,
        justification: npsJustification   
      }, npsSelected !== -1, [['requiredNps', 0], ['showModalMood', 0], ['haveToJustifyNps', 0], ['lastNpsScore', npsSelected]])
  
      const {status: npsStatus, data } = npsResponse;
      
      const userData = data.length ? data[0].attributes.response.userNpsAnswer : [];
      const npsUserAnswer = userData.length ? userData[0] : null;
      npsUserAnswerId = (npsStatus === 'success' && npsUserAnswer) ?? npsUserAnswer;
    }

    const origemAcessoMobile = 2;
    const moodResponse = await save('/api/v1/user/mood', {
        moodId: moodSelected,
        message: moodMessage,
        npsUserAnswerId: npsUserAnswerId,
        origemAcesso: origemAcessoMobile,
      }, moodSelected !== 0, [['requiredMood', 0], ['showModalMood', 0], ['moodId', moodSelected]])
    
    const isResponsesOk = moodResponse.status === 'success' && (npsResponse ? npsResponse.status === 'success' : true)

    if(isResponsesOk){
      const message = npsResponse
      ? t('mood.successBoth')
      : t('mood.successMood');

      setMessage(message);
      setMoodSelected(0);
      setNpsSelected(-1);
      setMoodMessage('');
      setIsOpen(false);
      setLastMoodSelected(moodSelected)
      setRequiredNPSAction(false);
      setNpsJustification('');
      setButtonIsDisabled(false);
      return;
    }
    setButtonIsDisabled(false);
    setMessage(t('mood.updateError'));
  }

  const handleButtonIsDisabled = () => {
    const isMoodSelected = moodSelected && moodSelected !== 0;
    const isNPSSelected = !!(npsSelected !== null && npsSelected !== undefined && npsSelected >= 0 && npsSelected !== -1);
    const moodWithJustification =requiredNPSAction && requiredNPSAction

    if (moodWithJustification && isNPSSelected) {
      if (npsSelected <= 6) {
        setMandatoryLabel(detractorsMustJustify);
      } else if (npsSelected <= 8) {
        setMandatoryLabel(passivesMustJustify);
      } else if (npsSelected <= 10) {
        setMandatoryLabel(promotersMustJustify);
      }
    }

    if (
      (requiredMoodAction && !isMoodSelected) ||
      requiredNPSAction && showNpsBox && (!isNPSSelected) ||
      ((showJustificationNpsInput && mandatoryLabel) ? npsJustification.trim() === '' : false)
      ) {
      setButtonIsDisabled(true);
    } else {
      setButtonIsDisabled(false);
    }
  }

  
  function getMoodModalTitle(requiredMood, requiredNps) {
    let title = "";

    const titles = {
      both: t('mood.both'),
      moodOnlyRequired: t('mood.moodOnlyRequired'),
      npsAndMood: t('mood.npsAndMood'),
      moodOnly: t('mood.moodOnly')
    };

    const moodAndNpsRequired = requiredMood && requiredNps;
    const moodRequiredOnly = requiredMood && !requiredNps;
    const moodNotRequiredAndNpsRequired = !requiredMood && requiredNps;
    const moodAndNpsNotRequired = !requiredMood && !requiredNps;

    if (moodAndNpsRequired) title = titles.both
    if (moodRequiredOnly) title = titles.moodOnlyRequired
    if (moodNotRequiredAndNpsRequired) title = titles.npsAndMood
    if (moodAndNpsNotRequired) title = titles.moodOnly

    setMoodModalTitle(title)
  } 

  useEffect(() => {
    if (loading){
      return;
    }
    handleButtonIsDisabled();
  }, [moodSelected, npsSelected, moodMessage, npsJustification, showJustificationNpsInput, showNpsBox, mandatoryLabel]);

  useEffect(() => {
    if (!isOpen) return;

    const localMood = JSON.parse(localStorage.getItem('USER_MOOD') || '{"user":{}, "mood":[]}');
    const {
      requiredMood,
      requiredNps,
      haveToJustifyNps,
      lastNpsScore,
      detractorsMustJustify,
      passivesMustJustify,
      promotersMustJustify
    } = localMood.user;
    const mood = localMood.mood;

    if (!mood.length) {
      setRequiredMoodAction(false);
      setRequiredNPSAction(false);
    }
    getMoodModalTitle(requiredMood, requiredNps)

    setMoods(mood);
    setRequiredMoodAction(!!requiredMood);
    setRequiredNPSAction(!!requiredNps);
    setShowJustificationNpsInput(!!haveToJustifyNps);
    setNpsSelected(lastNpsScore);
    setNpsJustification('');
    setDetractorsMustJustify(!!detractorsMustJustify)
    setPassivesMustJustify(!!passivesMustJustify)
    setPromotersMustJustify(!!promotersMustJustify)

    setNoData(requiredMood === undefined || requiredNps === undefined);
  },[isOpen]);

  const moodProps = {
    handleOnClose,
    moodSelected,
    requiredMoodAction,
    setMoodSelected,
    setMoodMessage,
    moodModalTitle
  }
  const npsProps = {
    npsSelected,
    setNpsSelected,
    setNpsId,
    setNpsJustification,
    showJustificationNpsInput,
    setShowNpsBox,
    requiredMoodAction,
    mandatoryLabel
  }

   return (
    <>
      <Modal
        open={isOpen || false}
        onClose={handleOnClose}
      >
        <>
          {noData 
            ? <NoDataMsg handleOnClose={handleOnClose} requiredMoodAction={requiredMoodAction}/>
            :<Container>
              <ModalHeader
                requiredMoodAction={requiredMoodAction}
              />
              <ContentContainer>
                {(requiredMoodAction || requiredNPSAction || isOpen) && <Mood {...moodProps}/>}
                {(moods.length > 0 && requiredNPSAction && showNpsBox) && <Nps {...npsProps}/>}
              </ContentContainer>
              {
                moods.length > 0 && (
                  <ModalFooter
                    onSave={saveData}
                    buttonIsDisabled={buttonIsDisabled}
                  />
                )
              }
            </Container>
          }
        </>
      </Modal>
      <ModalMessage
        open={!!message}
        message={message}
        onClose={() => setMessage('')}
      />
    </>

  )
}

const NoDataMsg = translate()(({ handleOnClose, requiredMoodAction, t}) => {
  return (
    <Container empty={true}>
      <ModalHeader
        requiredMoodAction={requiredMoodAction}
        handleOnClose={handleOnClose}
      />
      <SubHeader>{t('mood.moodNotFound')}</SubHeader>
      <SubTitle>{t('mood.loginAgain')}</SubTitle>
    </Container>
  )
})

const ModalHeader = translate()(({requiredMoodAction, t}) => {
  return (
    <>
      {requiredMoodAction && 
        <HeaderContainer>
          <SubHeader>{t('mood.actionRequired')} </SubHeader>
        </HeaderContainer>
      }
    </>
  )
}) 

const ModalFooter = translate()(({onSave, buttonIsDisabled, t}) => {
  return (
    <FooterContainer>
      <Button
        onClick={onSave}
        color="primary"
        variant="contained"
        disabled={buttonIsDisabled}
        data-testid="mood-modal-save-button"
      >
        {t('mood.save')} 
      </Button>
    </FooterContainer>
  )
})

export default translate('translation')(MoodModal)